const Styles = {
  headerStyle: {
    textAlign: 'center',
  },
};
export default Styles;
